import React from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import { AccessibleImage } from 'Components/accessibleImage'

interface WalkingPhotosProps {
  walkingPoints: any
  assetUrl?: string
}

const WalkingPhotos = ({ walkingPoints, assetUrl }: WalkingPhotosProps) => {
  const { locId } = useSelector((state: any) => state.location)
  const { stopPoints, nextStop, currentStop } = walkingPoints

  return (
    <>
      {stopPoints?.map((photo: any, index) => {
        const accessibilityText = `Currently on point ${index + 1} coming from ${
              currentStop.title
            } going to ${nextStop.title}`
        return (
          <div key={photo.media_id ?? index}>
            <Box
              component={'div'}
              sx={{
                width: '100%',
                height: 'auto',
                background: '#f2f3f4',
                textAlign: 'center',
              }}
            >
              <AccessibleImage
                src={`${assetUrl}/media/${locId}/tour/${photo.media_id}/1536_front.jpg`}
                alt={accessibilityText}
                tooltipTitle={accessibilityText}
                sx={{ width: '100%', height: 'auto' }}
              />
            </Box>
            <p>{`Currently on point ${index + 1} of ${
              stopPoints.length
            } coming from ${currentStop.title} going to ${nextStop.title}`}</p>
          </div>
      )
      })}
    </>
  )
}

export default WalkingPhotos
